import React, { useEffect } from 'react';
import { addLocale, PrimeReactProvider } from 'primereact/api';
import Router from './router';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContextProvider } from './Lib/Contexts/toastContext';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import './i18n';
import Snowfall from 'react-snowfall';

function App() {

  const isMarketingSite = typeof window !== 'undefined' && (window.location.hostname === 'mobithera-web-02-marketing.azurewebsites.net' || window.location.hostname === 'marketing.mobithera.com');

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
      },
      mutations: {
        retry: 1
      },
    }
  });

  addLocale('tr', {
    accept: 'Kabul Et',
    reject: 'Reddet',
    choose: 'Seç',
    upload: 'Yükle',
    cancel: 'İptal',
    dayNames: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
    dayNamesShort: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'],
    dayNamesMin: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
    monthNames: [
      'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
      'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
    ],
    monthNamesShort: [
      'Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz',
      'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'
    ],
    today: 'Bugün',
    clear: 'Temizle',
    weekHeader: 'Hf',
    firstDayOfWeek: 1,
    dateFormat: 'dd/mm/yy',
    weak: 'Zayıf',
    medium: 'Orta',
    strong: 'Güçlü',
    passwordPrompt: 'Şifrenizi girin',
    emptyMessage: 'Gösterilecek veri yok',
    emptyFilterMessage: 'Eşleşen sonuç bulunamadı',
    filter: 'Filtre',
    equals: 'Eşittir',
    notEquals: 'Eşit Değil',
    startsWith: 'İle Başlayan',
    contains: 'İçeren',
    notContains: 'İçermeyen',
    endsWith: 'İle Biten',
    lt: 'Küçük',
    lte: 'Küçük veya Eşit',
    gt: 'Büyük',
    gte: 'Büyük veya Eşit',
    dateIs: 'Tarih',
    dateIsNot: 'Tarih Değil',
    dateBefore: 'Önceki Tarih',
    dateAfter: 'Sonraki Tarih',
    apply: "Uygula"
  });

  const [showSnowfall, setShowSnowfall] = React.useState(false);

  useEffect(() => {
    if (!isMarketingSite) return;
    const timer = setTimeout(() => setShowSnowfall(false), 60000);
    return () => clearTimeout(timer);
  }, [isMarketingSite]);

  const clientId = process.env.REACT_APP_CLIENT_ID_DEV;

  const snows = React.useMemo(() => {
    if (!isMarketingSite) return [] as HTMLImageElement[];
    const image = document.createElement('img');
    image.src = '/snow.png';
    return [image];
  }, [isMarketingSite]);

  return (
    <>
      {showSnowfall && isMarketingSite && (
        <Snowfall radius={[10, 10]} snowflakeCount={25} images={snows} style={{ zIndex: 9999 }} />
      )}
      <DndProvider backend={HTML5Backend}>
        <QueryClientProvider client={queryClient}>
          <GoogleOAuthProvider clientId={clientId as any}>
            <PrimeReactProvider>
              <ToastContextProvider>
                <Router />
              </ToastContextProvider>
            </PrimeReactProvider>
          </GoogleOAuthProvider>
        </QueryClientProvider>
      </DndProvider>
    </>
  );
}

export default App;
